import request from "../request"
import { ApiAddress } from "../apis"

type ID = number
export interface ComponentTransitionMaping {
  out: ID,
  in: ID
}

export interface PPSTransitionRecord {
  stream: string,
  pps: string,
  inletPps: string
  map: ComponentTransitionMaping[]
  isTransition: boolean
}

export const getPPSTransitionRecords = (sId: number): Promise<PPSTransitionRecord[]> => {
  return request.get(ApiAddress.SIM_PPS_TRANSITIONS, {params: {sId}, headers: {'SIM-TOKEN': '1111'}})
}

export const createPPSTransitionRecords = (body, sId: number): Promise<PPSTransitionRecord> => {
  return request.post(ApiAddress.SIM_PPS_TRANSITIONS, body, {params: {sId}, headers: {'SIM-TOKEN': '1111'}})
}

export const updatePPSTransitionRecords = (body, params): Promise<PPSTransitionRecord> => {
  return request.put(ApiAddress.SIM_PPS_TRANSITION, body, {params, headers: {'SIM-TOKEN': '1111'}})
}

export const deletePPSTransitionRecords = (id: number, sId: number): Promise<PPSTransitionRecord> => {
  return request.delete(ApiAddress.SIM_PPS_TRANSITION, {params: {sId, id}, headers: {'SIM-TOKEN': '1111'}})
}